import { useFormContext } from 'react-hook-form';

import { Card } from '@shared/ui';

import { numberMask } from 'library/helpers/events/timePicker';

import * as st from './styles.module.scss';
import { CustomEditorInputControlled } from '@src/modules/Authentication/InputsControlled';

export const Refusal = (): JSX.Element => {
    const { control } = useFormContext();


    return (
        <fieldset>
            <div className={st.header}>
                <h3>Отмена</h3>
            </div>

            <Card className={st.refusal}>
                <div className={st.refusal__input}>
                    <CustomEditorInputControlled
                        control={control}
                        name="refusal"
                        label=""
                        sufix={'час'}
                        mask={numberMask}
                    />
                </div>
                <p className={st.refusal__explanation}>
                    Время, за которое клиент может отказаться от участия в мероприятии до его начала (со 100% возвратом средств)
                </p>
            </Card>

        </fieldset>
    );
};